
import React, { useState } from 'react';
import { Banner } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

export interface ActionRequiredBannerProps {}

export const ActionRequiredBanner: React.FC<ActionRequiredBannerProps> = () => {
  const translate = useTranslation();

  const [showBanner, setShowBanner] = useState(() => {
    // Check localStorage to see if banner was previously dismissed
    const bannerDismissed = localStorage.getItem('actionRequiredBannerDismissed');
    return bannerDismissed !== 'true';
  });

  const onBannerClose = () => {
    setShowBanner(false);
    // Store in localStorage so banner doesn't show again
    localStorage.setItem('actionRequiredBannerDismissed', 'true');
  };

  const handleLearnMoreClick = () => {
    window.open('assets/Action Required - Ensure Seamless and Secure Online Payments.pdf', '_blank');
  };

  if (!showBanner) {
    return null;
  }

  return (
      <Banner
        severity='risky'
        title={translate('Take action to avoid delays and keep online bank account payments seamless.')}
        description={translate('Please re-enter and save your bank account details in our new payment portal, even if previously submitted. Then, inform your bank of our updated ACH ID ({0}) and new partner, Paymentus.', ['0000408976'])}
        onClose={onBannerClose}
        actionOne={{
          buttonText: translate('Learn More'),
          onClick: handleLearnMoreClick
        }}
      />
  );
};